export enum PolicyTypes {
	GeneralLiability = 'General Liability',
	WorkersComp = 'Workers Comp.',
	OccupationalLicense = 'Occupational License',
	CertOfExemption = 'Cert. of Exemption',
	Other = 'Other',
}
